export default __webpack_public_path__ + "static/media/Look at me .30872651.jpg";